import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';

import WbLoginPage from './wb-preview/WbLoginPage';
import WbClientDashboard from './wb-preview/WbClientDashboard';
import WbClientInterface from './wb-preview/WbClientInterface';
import WbCampaignDetail from './wb-preview/WbCampaignDetail';
import WbAdminAccess from './wb-preview/WbAdminAccess';
import WbAdminScriptErrors from './wb-preview/WbAdminScriptErrors';
import CampaignList from './pages/CampaignList';
import SchedulerPage from './pages/SchedulerPage';
import BidderRules from './pages/BidderRules';
import BudgetPage from './pages/BudgetPage';
import UnitEconomicsPage from './pages/UnitEconomicsPage';
import RulesEditor from './pages/RulesEditor';
import MvpHub from './mvp/MvpHub';
import { isAuthenticated as getIsAuthenticated, subscribeAuthChange } from './utils/auth';

function WbPreviewClientRedirect() {
  const { clientId } = useParams();
  return <Navigate to={`/client/${clientId}`} replace />;
}

function WbPreviewCampaignRedirect() {
  const { clientId, advertId } = useParams();
  return <Navigate to={`/client/${clientId}/campaign/${advertId}`} replace />;
}

export default function AppRouter() {
  const [isAuthenticated, setIsAuthenticated] = useState(getIsAuthenticated());

  useEffect(() => subscribeAuthChange(() => setIsAuthenticated(getIsAuthenticated())), []);

  const auth = (element) => (isAuthenticated ? element : <Navigate to="/login" replace />);

  return (
    <Routes>
      <Route path="/login" element={<WbLoginPage />} />
      <Route path="/dashboard" element={auth(<WbClientDashboard />)} />
      <Route path="/admin/access" element={auth(<WbAdminAccess />)} />
      <Route path="/admin/script-errors" element={auth(<WbAdminScriptErrors />)} />
      <Route path="/client/:clientId" element={auth(<WbClientInterface />)} />
      <Route path="/hub/:clientId" element={auth(<MvpHub />)} />
      <Route
        path="/client/:clientId/campaigns"
        element={auth(<CampaignList />)}
      />
      <Route
        path="/client/:clientId/campaign/:advertId"
        element={auth(<WbCampaignDetail />)}
      />
      <Route path="/scheduler" element={auth(<SchedulerPage />)} />
      <Route path="/bidder" element={auth(<BidderRules />)} />
      <Route path="/budget" element={auth(<BudgetPage />)} />
      <Route
        path="/reports/unit_economics"
        element={auth(<UnitEconomicsPage />)}
      />
      <Route path="/rules" element={auth(<RulesEditor />)} />

      {/* Старые preview-URL → основные маршруты */}
      <Route path="/wb-preview/login" element={<Navigate to="/login" replace />} />
      <Route path="/wb-preview/dashboard" element={<Navigate to="/dashboard" replace />} />
      <Route
        path="/wb-preview/client/:clientId/campaign/:advertId"
        element={<WbPreviewCampaignRedirect />}
      />
      <Route path="/wb-preview/client/:clientId" element={<WbPreviewClientRedirect />} />
      <Route path="/wb-preview/*" element={<Navigate to="/dashboard" replace />} />

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
